import gql from 'graphql-tag'

export const COMMENT_CREATE_MUTATION = gql`
    mutation commentCreate(
        $comment: CommentInputCreate!
    ) {
        commentCreate(
            comment: $comment
        ) {
            id
            creator {
                id
                contact_number
                first_name
                last_name
                gender
                title
                consultingCompany {
                    id
                }
                consulting_company_name
            }

            text
            pinned

            created_at
            updated_at
        }
    }
`
